var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "form",
                            attrs: { model: _vm.form, "label-width": "85px" }
                          },
                          [
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "输入搜索：" } },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 2 } },
                                          [
                                            _vm.address
                                              ? _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      placeholder: "发货仓"
                                                    },
                                                    model: {
                                                      value: _vm.form.city,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "city",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "form.city"
                                                    }
                                                  },
                                                  _vm._l(_vm.address, function(
                                                    item1
                                                  ) {
                                                    return _c("el-option", {
                                                      key: item1.key,
                                                      attrs: {
                                                        label: item1.label,
                                                        value: item1.key
                                                      }
                                                    })
                                                  }),
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 2 } },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "订单号" },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.order_sn,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "order_sn",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.order_sn"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 2 } },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "工单id" },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.work_id,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "work_id",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.work_id"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "商品名称"
                                              },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.goods_name,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "goods_name",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.goods_name"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "货号" },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.goods_no,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "goods_no",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.goods_no"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "处理人" },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.handle_admin,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "handle_admin",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.handle_admin"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _vm.resData
                                              ? _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      placeholder: "状态"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.handle_status,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "handle_status",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.handle_status"
                                                    }
                                                  },
                                                  [
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "全部",
                                                        value: ""
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "待处理",
                                                        value: "1"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "已处理",
                                                        value: "2"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "创建人" },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.create_admin,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "create_admin",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.create_admin"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 7 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "生成时间：" } },
                                      [
                                        _c("el-date-picker", {
                                          attrs: {
                                            type: "datetimerange",
                                            "value-format":
                                              "yyyy-MM-dd HH:mm:ss",
                                            "range-separator": "至",
                                            "start-placeholder": "开始日期",
                                            "end-placeholder": "结束日期",
                                            "default-time": [
                                              "06:00:00",
                                              "06:00:00"
                                            ]
                                          },
                                          model: {
                                            value: _vm.form.add_time,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "add_time",
                                                $$v
                                              )
                                            },
                                            expression: "form.add_time"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 7 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "拆包时间：" } },
                                      [
                                        _c("el-date-picker", {
                                          attrs: {
                                            type: "datetimerange",
                                            "value-format":
                                              "yyyy-MM-dd HH:mm:ss",
                                            "range-separator": "至",
                                            "start-placeholder": "开始日期",
                                            "end-placeholder": "结束日期",
                                            "default-time": [
                                              "06:00:00",
                                              "06:00:00"
                                            ]
                                          },
                                          model: {
                                            value: _vm.form.create_time,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "create_time",
                                                $$v
                                              )
                                            },
                                            expression: "form.create_time"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 7 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "处理时间：" } },
                                      [
                                        _c("el-date-picker", {
                                          attrs: {
                                            type: "datetimerange",
                                            "value-format":
                                              "yyyy-MM-dd HH:mm:ss",
                                            "range-separator": "至",
                                            "start-placeholder": "开始日期",
                                            "end-placeholder": "结束日期",
                                            "default-time": [
                                              "06:00:00",
                                              "06:00:00"
                                            ]
                                          },
                                          model: {
                                            value: _vm.form.handle_time,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "handle_time",
                                                $$v
                                              )
                                            },
                                            expression: "form.handle_time"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 2 } },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.search }
                                      },
                                      [_vm._v("查询")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c("div", [_vm._v("数据列表：")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "auto" },
                    attrs: { type: "success", size: "mini" },
                    on: { click: _vm.output }
                  },
                  [_vm._v("导出")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "margin-bottom": "0" } },
                  [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          height: "600",
                          data: _vm.resData.list,
                          "tooltip-effect": "dark"
                        },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "create_admin_name",
                            label: "异常工单创建人",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "create_time",
                            label: "拆包时间",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "order_sn",
                            label: "订单号",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "work_id",
                            label: "工单ID",
                            align: "center",
                            width: "100"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleClick(
                                              scope.row.work_id,
                                              scope.row.user_refund_id
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(scope.row.work_id))]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4193325444
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "service_order_handle_type",
                            label: "工单类型",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "add_time",
                            label: "工单生成时间",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_name",
                            label: "商品名称",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "back_shipping_num",
                            label: "商品图片",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          width: "70px",
                                          height: "70px"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            width: "100%",
                                            height: "100%"
                                          },
                                          attrs: { src: scope.row.goods_img },
                                          on: {
                                            click: function($event) {
                                              return _vm.showImages(
                                                scope.row.imgs
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2349661514
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_no",
                            label: "货号",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "co_val",
                            label: "颜色",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "si_val",
                            label: "尺码",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_number",
                            label: "工单件数",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "unpacking_num",
                            label: "已拆包件数",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "handle_admin",
                            label: "处理人",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "handle_remark",
                            label: "处理人备注",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "handle_time",
                            label: "处理时间",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "",
                            label: "操作",
                            align: "center",
                            width: "100",
                            fixed: "right"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.status == 1
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  type: "primary"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleAbnormalWork(
                                                      scope.row.abnormal_id
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("待处理")]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.status == 2
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  type: "info"
                                                }
                                              },
                                              [_vm._v("已完成")]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2651488930
                          )
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.curPage,
                        background: "",
                        layout: "total, prev, pager, next, jumper ",
                        total: _vm.resData.count,
                        "page-size": 10
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.curPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.curPage = $event
                        },
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("preview-image", {
        attrs: { imgs: _vm.images, show: _vm.showbox },
        on: {
          closeBox: function($event) {
            return _vm.closeBox()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b957967e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b957967e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/work/AbnormalWorkList.vue
// module id = null
// module chunks = 